import { render, staticRenderFns } from "./myPopup.vue?vue&type=template&id=3bd0afc7&scoped=true"
import script from "./myPopup.vue?vue&type=script&lang=js"
export * from "./myPopup.vue?vue&type=script&lang=js"
import style0 from "./myPopup.vue?vue&type=style&index=0&id=3bd0afc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd0afc7",
  null
  
)

export default component.exports